import { atom } from 'recoil'

export const userDetails = atom({
  key: 'userDetails', // unique ID (with respect to other atoms/selectors)
  default: '', // default value (aka initial value)
})

export const bearerToken = atom({
  key: 'bearerToken', // unique ID (with respect to other atoms/selectors)
  default: '', // default value (aka initial value)
})
